(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4443],{

/***/ 4702:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[[...blog]]",
      function () {
        return __webpack_require__(16900);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7154);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47956);







const BreadCrumb = (props)=>{
    const { data: { appliedCssClassNames ="" , items =[]  } , fullData ={}  } = props;
    const { carousel: { carouselComponentProperties: { appliedCssClassNames: carouselClassName = ""  } = {}  } = {}  } = fullData;
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const ITEM_TYPE = {
        breadcrumbList: "http://schema.org/BreadcrumbList",
        listItem: "http://schema.org/ListItem"
    };
    const [eventPageName, setEventPageName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [shortURLs, setShortURLs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [componentGroup, setComponentGroup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const urls = items.map((navItem)=>navItem.url);
        Promise.all(urls.map(_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Ppy)).then((res)=>setShortURLs(res));
    }, [
        items
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isSsr) return;
        setEventPageName(window.eventPageType);
    }, [
        isSsr
    ]);
    // #ToDo Hard coding zone value once received data from json will change
    const zone = "hero banner";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.TEASER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.CAROUSEL);
            }) && carouselClassName === "carousel-navigation-cta-left-right") {
                setColumnClassNames((className)=>className += " breadcrumb-overlay");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.CAROUSEL);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.CONTAINER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    const getEventInfo = (navItem, index)=>{
        if (isSsr) {
            return JSON.stringify({
                clickInternalLinks: "true",
                eventAction: eventPageName + ":" + zone + ":breadcrumb",
                eventName: eventPageName + ":" + zone + ":breadcrumb",
                eventType: eventPageName,
                internalLinkName: navItem === null || navItem === void 0 ? void 0 : navItem.title,
                internalLinkPosition: "main content area",
                internalLinkType: window.storeLinkType ? window.storeLinkType : eventPageName + ":breadcrumb",
                internalLinkURL: navItem === null || navItem === void 0 ? void 0 : navItem.url,
                internalLinkZoneName: eventPageName + ":" + zone
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "breadcrumb ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(columnClassNames),
            children: items.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                id: "breadcrumb",
                className: "cmp-breadcrumb",
                "aria-label": "Breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: "cmp-breadcrumb__list",
                    itemScope: true,
                    itemType: ITEM_TYPE.breadcrumbList,
                    children: items.map((navItem, index)=>{
                        var ref;
                        const isLastItem = index === items.length - 1;
                        const isActive = navItem.active;
                        const shouldRenderSlash = !isActive && !isLastItem && !items[index + 1].active || ((ref = items[index + 1]) === null || ref === void 0 ? void 0 : ref.current);
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "cmp-breadcrumb__item".concat(navItem.active ? " cmp-breadcrumb__item--active" : ""),
                            itemProp: "itemListElement",
                            itemScope: true,
                            itemType: ITEM_TYPE.listItem,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: shortURLs[index],
                                    className: "cmp-breadcrumb__item-link",
                                    itemProp: "item",
                                    "data-zone": zone,
                                    "aria-label": navItem.title,
                                    "aria-current": navItem.active || isLastItem ? "page" : null,
                                    "data-gbh-data-layer": !isSsr && getEventInfo(navItem, index),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        itemProp: "name",
                                        dangerouslySetInnerHTML: {
                                            __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(navItem === null || navItem === void 0 ? void 0 : navItem.title)
                                        }
                                    })
                                }),
                                " ",
                                shouldRenderSlash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "cmp-breadcrumb-slash",
                                            "aria-hidden": "true"
                                        }),
                                        "\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    itemProp: "position",
                                    content: index + 1
                                })
                            ]
                        }, "breadcrumb-item-".concat(index));
                    })
                })
            }) : null
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);


/***/ }),

/***/ 16900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3939);
/* harmony import */ var _components_Default_BreadCrumb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42053);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10884);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82660);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82706);
/* eslint-disable require-jsdoc */ 





const Blog = (param)=>{
    let { tmpData: data , headertmp: header , footertmp: footer , globalScript , footerScript , analysticsScript  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            header: header,
            title: data.title,
            globalScripting: globalScript,
            analysticsScript: analysticsScript
        }),
        footer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            footer: footer,
            footerScripting: footerScript
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "min-vh-100",
            style: {
                background: "transparent"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                data: data,
                count: 0,
                breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Default_BreadCrumb__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        data: data,
                        fullData: fullData
                    })
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Blog);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,6351,6342,4432,7333,4904,361,9851,5921,4204,4382,4547,9774,2888,179], function() { return __webpack_exec__(4702); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);